import React from 'react';
import { ArrowRight, CheckCircle, Terminal } from 'lucide-react';
import { Link } from 'react-router-dom';
import CompanyLogos from '../components/CompanyLogos';

const ServicePage = ({ title, description, benefits }) => {
    const defaultBenefits = [
        "Industry-leading expertise",
        "Tailored solutions for your business",
        "Scalable and secure assessments",
        "24/7 Support and Maintenance",
        "Innovative technology stack"
    ];

    const displayBenefits = benefits || defaultBenefits;

    return (
        <div className="min-h-screen bg-brand-bg">
            {/* Hero Section */}
            <div className="bg-gradient-to-r from-slate-900 to-slate-800 text-brand-textLight py-20 px-6 sm:px-12 lg:px-24">
                <div className="max-w-7xl mx-auto">
                    <div className="md:w-3/4 lg:w-2/3">
                        <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                            {title}
                        </h1>
                        <p className="text-xl text-brand-textMuted mb-8 max-w-2xl">
                            {description || `Explore our cutting-edge ${title} solutions designed to transform your business and drive innovation.`}
                        </p>
                        <Link
                            to="/contact-us"
                            className="inline-flex items-center px-8 py-4 bg-brand-gold text-black font-bold rounded-lg shadow-lg hover:bg-brand-goldHover transition-transform transform hover:-translate-y-1"
                        >
                            Get Started
                            <ArrowRight className="ml-2 h-5 w-5" />
                        </Link>
                    </div>
                </div>
            </div>

            {/* Scrolling Company Logos Section */}
            <CompanyLogos />

            {/* Main Content */}
            <div className="max-w-7xl mx-auto py-16 px-6 sm:px-12 lg:px-24">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">

                    {/* Program Overview */}
                    <div className="lg:col-span-2 space-y-8">
                        <div className="bg-brand-card p-8 rounded-2xl shadow-sm border border-gray-800">
                            <h2 className="text-2xl font-bold text-brand-textLight mb-6 flex items-center">
                                <Terminal className="text-brand-gold mr-3" size={28} />
                                Overview
                            </h2>
                            <p className="text-brand-textMuted leading-relaxed mb-6">
                                Our {title} services provide comprehensive solutions tailored to your specific needs. We leverage the latest technologies and methodologies to deliver high-quality results that drive business growth.
                            </p>
                            <p className="text-brand-textMuted leading-relaxed">
                                Whether you are looking to modernize your infrastructure, implement AI solutions, or secure your digital assets, our team of experts is here to help you every step of the way.
                            </p>
                        </div>
                    </div>

                    {/* Sidebar / CTA */}
                    <div className="lg:col-span-1">
                        <div className="bg-brand-card text-brand-textLight p-8 rounded-2xl shadow-xl sticky top-24">
                            <h3 className="text-2xl font-bold mb-6">Why Choose Us?</h3>
                            <ul className="space-y-4 mb-8">
                                {displayBenefits.map((item, index) => (
                                    <li key={index} className="flex items-start">
                                        <CheckCircle className="text-brand-gold mr-3 mt-1 flex-shrink-0" size={18} />
                                        <span className="text-brand-textMuted">{item}</span>
                                    </li>
                                ))}
                            </ul>
                            <div className="space-y-4">
                                <Link to="/contact-us" className="block w-full py-3 bg-brand-gold hover:bg-brand-goldHover text-center text-black font-bold rounded-lg transition-colors">
                                    Contact Us
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ServicePage;
